// extracted by mini-css-extract-plugin
module.exports = {"MenuFooter":"styles_MenuFooter__DQDGI","height":"styles_height__EsJc0"};